import {object, string, number} from "yup";

export default {
    participant: object().shape({
        big: string().matches(/^([0-9]+)$/, {message: 'Voer een geldig BIG/KRM-nummer in (uitsluitend cijfers, geen letters of streepjes)', excludeEmptyString: true}).label('BIG/KRM nummer'),
        firstName: string().required().label('Voornaam'),
        initials: string().required().label('Voorletters'),
        lastName: string().required().label('Achternaam'),
        email: string().required().email().label('Email'),
        job: string().required().label('Functie'),
        address: object({
            streetname: string().required().label('Straatnaam'),
            city: string().required().label('Stad'),
            zipcode: string().required().label('Postcode'),
            housenumber: string().required().label('Huisnummer'),
            suffix: string().label('Toevoeging'),
        }),
    }),

    invoiceParticipant: object().shape({
        big: string().matches(/^([0-9]+)$/, {message: 'Voer een geldig BIG/KRM-nummer in (uitsluitend cijfers, geen letters of streepjes)', excludeEmptyString: true}).label('BIG/KRM nummer'),
        initials: string().required().label('Voorletters'),
        firstName: string().required().label('Voornaam'),
        lastName: string().required().label('Achternaam'),
        phone: string().required().label('Telefoonnummer'),
        email: string().required().email().label('Email'),
        job: string().required().label('Functie'),
        address: object({
            streetname: string().required().label('Straatnaam'),
            city: string().required().label('Stad'),
            zipcode: string().required().label('Postcode'),
            housenumber: string().required().label('Huisnummer'),
            suffix: string().label('Toevoeging'),
        }),
    }),

    invoice: object().shape({
        initials: string().required().label('Voorletters'),
        firstName: string().required().label('Voornaam'),
        lastName: string().required().label('Achternaam'),
        email: string().required().email().label('Email'),
        phone: string().required().label('Telefoonnummer'),
        organisation: string().required().label('Organisatie'),
        address: object({
            streetname: string().required().label('Straatnaam'),
            city: string().required().label('Stad'),
            zipcode: string().required().label('Postcode'),
            housenumber: string().required().label('Huisnummer'),
            suffix: string().label('Toevoeging'),
        }),
    }),
}
